export const rootConstants = {
  DOWN: 'DOWN',
  LOADING: 'LOADING',

  BYPASS_PARAMS_REQUESTED: 'BYPASS_PARAMS_REQUESTED',
  BYPASS_PARAMS_LOADED: 'BYPASS_PARAMS_LOADED',
  BYPASS_PARAMS_LOADED_WITH_ERROR: 'BYPASS_PARAMS_LOADED_WITH_ERROR',
};
